
export function getText(text: string) {
    return text
}

export function firstCapital(text: string) {
    return text.charAt(0).toLocaleUpperCase() + text.substr(1)
}